type MarketplaceCode = 'wb' | 'ozon' | 'ym' | 'site'

export interface SlideInsertPrefill {
  contentAssetId?: number
  sourceImageUrl?: string
  scopeKind?: 'bundle' | 'theme'
  bundleIds?: number[]
  themeNumber?: number
  marketplaces?: MarketplaceCode[]
  sellerIds?: number[]
  categoryIds?: number[]
  insertId?: number
  /** Initial coverage filter for links from summary counters. */
  cardStatus?: string
}
export interface SlideInsertInput extends SlideInsertPrefill {
  name: string
  scopeKind: 'bundle' | 'theme'
  positionMode: 'end' | 'index'
  positionIndex: number | null
  overflowPolicy: 'skip_card' | 'drop_last'
  applyToNew: boolean
  revision?: number
}
export interface InsertCard {
  card_id: number
  article: string
  marketplace: MarketplaceCode
  seller_id: number
  seller_name?: string
  status: string
  reason?: string | null
  send_status?: string
}
export interface InsertCounts {
  total: number
  draft: number
  pending: number
  sent: number
  skipped: number
  excluded: number
}
export interface SlideInsert {
  id: number
  name: string
  content_asset_id: number
  status: 'draft' | 'active' | 'disabled' | 'archived'
  position_mode: 'end' | 'index'
  position_index: number | null
  scope_kind: 'bundle' | 'theme'
  overflow_policy: 'skip_card' | 'drop_last'
  apply_to_new: boolean
  revision: number
  updated_at: string
  scopes: Array<{
    bundle_id?: number
    theme_number?: number
    marketplace?: MarketplaceCode
    seller_id?: number
    category_id?: number
  }>
  counts: InsertCounts
  events?: Array<{
    id: number
    event_type?: string
    type?: string
    created_at: string
    message?: string
    user_name?: string
  }>
  sendEnabled?: boolean
  sendBreakdown?: Array<{
    marketplace: MarketplaceCode
    seller_id: number
    seller_name?: string
    count: number
  }>
  mixedChanges?: number
}
export interface InsertPreview {
  total: number
  eligible: number
  drafts: number
  pending: number
  skipped: number
  mixedChanges: number
  cards: InsertCard[]
  samples: Array<{
    card_id: number
    article: string
    marketplace: MarketplaceCode
    seller_name?: string
    urls: string[]
    insertUrl?: string
    limit: number
  }>
  facets?: {
    sellers: Array<{ id: number; name: string; count: number; marketplace?: MarketplaceCode }>
    categories: Array<{ id: number; name: string; count: number }>
  }
}
export const INSERT_STATUS_LABELS = {
  draft: 'Черновик',
  active: 'Действует',
  disabled: 'Снимается',
  archived: 'В архиве',
}
export const CARD_STATUS_LABELS: Record<string, string> = {
  applied: 'Применено',
  draft: 'Черновик обновлён',
  pending: 'Ждёт отправки',
  sent: 'Отправлено',
  skipped: 'Пропуск',
  excluded: 'Исключено',
  error: 'Ошибка',
}
export const INSERT_REASON_LABELS: Record<string, string> = {
  scope_changed: 'Карточка больше не входит в охват вставки',
  already_present: 'Такая картинка уже есть',
  overflow: 'Галерея заполнена',
  photo_limit: 'Достигнут лимит фото',
  in_flight: 'Карточка сейчас отправляется',
  no_cabinet_token: 'Нет кабинета или доступа к нему',
  no_base_gallery: 'Нет исходной галереи',
  already_has_image: 'Такая картинка уже есть',
}
export const INSERT_EVENT_LABELS: Record<string, string> = {
  created: 'Создана',
  applied: 'Применена',
  image_replaced: 'Картинка заменена',
  position_changed: 'Место изменено',
  scope_changed: 'Охват изменён',
  updated: 'Изменена',
  disabled: 'Снята',
  archived: 'В архиве',
  excluded: 'Карточка исключена',
  included: 'Карточка возвращена',
  sent: 'Отправлена',
  deleted: 'Удалена',
  recalculated: 'Охват пересчитан',
}

export interface ScopeSearchMatch {
  type: 'design' | 'product' | 'card' | 'theme' | 'bundle' | 'name'
  value: string
  article?: string
  designCode?: string
  themeNumber?: number
  cardCode?: string
  marketplace?: MarketplaceCode
  sellerName?: string
}
export interface ScopeSearchItem {
  kind: 'theme' | 'bundle'
  id: number
  title: string
  themeNumber?: number
  marketplace?: MarketplaceCode
  sellerId?: number
  sellerName?: string
  externalBundleId?: string | null
  cardCount: number
  categories: Array<{ id: number; code: string; name: string }>
  matchQuality: 'exact' | 'partial'
  matches: ScopeSearchMatch[]
}
export interface ScopeSearchParams {
  scopeKind: 'theme' | 'bundle'
  q?: string
  marketplace?: MarketplaceCode
  sellerId?: number
  categoryId?: number
  ids?: string
  limit?: number
  offset?: number
}
export interface ScopeSearchResult {
  items: ScopeSearchItem[]
  total: number
  limit: number
  offset: number
  unbundledMatches?: ScopeSearchMatch[]
}
